import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseContractSignatureReminderTemplates = [
  {
    id: '-109001',
    language: Language.EN,
    subject: 'Reminder: Lease contract to be signed',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNATURE_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear tenant,</p>
        <p></p>
        <p>Concerns: invitation to sign the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>We kindly remind you to sign your lease by connecting to your account:</p>
        <ul>
        <li>Link: <strong>{{connectionLink}}</strong></li>
        <li>Comment: <i>{{additionalMessage}}</i></li>
        </ul>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-109002',
    language: Language.FR,
    subject: 'Rappel: contrat de bail à signer',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNATURE_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère locataire,</p>
        <p></p>
        <p>Concerne: rappel de l'invitation à signer le bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Nous vous invitons à signer votre bail en vous connectant à votre compte utilisateur:</p>
        <ul>
        <li>Lien: <strong>{{connectionLink}}</strong></li>
        <li>Commentaire: <i>{{additionalMessage}}</i></li>
        </ul>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-109003',
    language: Language.NL,
    subject: 'Herinnering: te ondertekenen huurcontract',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNATURE_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte huurder,</p>
        <p></p>
        <p>Betreffende: herinnering aan de uitnodiging om uw huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong> te ondertekenen.</p>
        <p></p>
        <p>We nodigen u uit om uw huurcontract te ondertekenen door in te loggen op uw account:</p>
        <ul>
        <li>Link: <strong>{{connectionLink}}</strong></li>
        <li>Opmerking: <i>{{additionalMessage}}</i></li>
        </ul>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-109004',
    language: Language.DE,
    subject: 'Erinnerung: zu unterzeichnender Mietvertrag',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNATURE_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r Mieter/in,</p>
        <p></p>
        <p>Betreff: Erinnerung an die Einladung zur Unterzeichnung des Mietvertrags in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Wir erinnern Sie freundlich daran, Ihren Mietvertrag zu unterzeichnen, indem Sie sich in Ihr Konto einloggen:</p>
        <ul>
        <li>Link: <strong>{{connectionLink}}</strong></li>
        <li>Kommentar: <i>{{additionalMessage}}</i></li>
        </ul>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
